export const basicFormData = () => ({
  inputData: {
    uom_name: "",
    is_active: true,
    created_by: null,
    updated_by: null,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "uom_masters",
  };

  const navigatePage = { back: "/uom-list" };

  const headerName = "UOM";

  const validationType = "UOMCreate";
  const createEndpoint = "/createUom";
  const updateEndpoint = "/updateUom";
  const getEndpoint = "/getUomById";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const payload = {
    modelName: "uom_masters",
    relations: [
      {
        module: "user_masters",
        moduleAs: "createdBy",
      },
      {
        module: "user_masters",
        moduleAs: "updatedBy",
      },
    ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "UOM", value: "uom_name" },
    { label: "Created By", value: "createdBy.first_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/uom-create",
    edit: "/uom-create",
    view: "/uom-view",
  };

  const searchfields = [
    "uom_name",
    "createdBy.first_name",
    "createdBy.last_name",
    "updatedBy.first_name",
    "updatedBy.last_name",
  ];

  const headerName = "UOM";
  const endpoint = "/listUom";
  const exportFileName = "uomData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "uom_masters",
  relations: [
    { module: "user_masters", moduleAs: "createdBy" },
    { module: "user_masters", moduleAs: "updatedBy" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
